import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { fwcBorderWidth } from 'foundations-theming/utils/fwc';
import {
  TABLE_CELL_HEIGHT,
  TABLE_CELL_VERTICAL_ALIGNMENT,
  TABLE_COMPACT_CELL_HEIGHT,
  TABLE_HEADER_HEIGHT,
} from '../../constants/Sizes';

export const useTableStyles = () => {
  const theme = useTheme();

  const defaultPadding = {
    paddingInline: theme.space['600'],
    paddingBlock: theme.space['400'],
  };

  const condensedPadding = {
    paddingInline: theme.space['600'],
    paddingBlock: theme.space['200'],
  };

  return {
    defaultPadding,
    condensedPadding,
    tableHeaderHeight: TABLE_HEADER_HEIGHT,
    tableCellHeight: TABLE_CELL_HEIGHT,
    tableCellHeightCompact: TABLE_COMPACT_CELL_HEIGHT,
    tableCellVerticalAlignment: TABLE_CELL_VERTICAL_ALIGNMENT,
  };
};

export const useTableCellBorderStyles = ({
  interiorBorders = false,
  isHeader = false,
  exteriorBorders = true,
}: {
  interiorBorders?: boolean;
  isHeader?: boolean;
  exteriorBorders?: boolean;
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const exteriorBorderWidth = isTrellis
    ? theme.borderWidth[
        fwcBorderWidth('fwc-table-header-divider-width-default')
      ]
    : theme.borderWidth['100'];

  return {
    borderWidth: theme.borderWidth['0'],
    borderStyle: 'solid',
    borderColor: theme.color['border-transitional-core-subtle'],
    borderInlineEndWidth: exteriorBorderWidth,
    borderBlockEndWidth: theme.borderWidth['100'],
    ...(isHeader && {
      borderBlockStartWidth: exteriorBorderWidth,
    }),
    '&:first-child': {
      ...(exteriorBorders && {
        borderInlineStartWidth: exteriorBorderWidth,
      }),
    },
    ...(!interiorBorders && {
      '&:not(:first-child)': {
        borderInlineStartWidth: theme.borderWidth['0'],
      },
      '&:not(:last-child)': {
        borderInlineEndWidth: theme.borderWidth['0'],
      },
    }),
    ...(!exteriorBorders && {
      '&:last-child': {
        borderInlineEndWidth: theme.borderWidth['0'],
      },
    }),
  };
};
